const ACCESS_TOKEN_KEY = "bp_access_token";

const readPersistedToken = () => {
  try {
    return localStorage.getItem(ACCESS_TOKEN_KEY) || null;
  } catch {
    return null;
  }
};

const persistToken = (token) => {
  try {
    if (token) {
      localStorage.setItem(ACCESS_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
    }
  } catch {
    // Storage unavailable (private mode / quota); fall back to in-memory only.
  }
};

let _accessToken = readPersistedToken();
let _sessionExpiredEventSent = false;

export const tokenService = {
  getAccessToken: () => _accessToken,
  setAccessToken: (token) => {
    _accessToken = token;
    if (token) {
      _sessionExpiredEventSent = false;
    }
    persistToken(token);
  },
  clear: () => {
    _accessToken = null;
    persistToken(null);
  },
};

export function sessionExpired() {
  tokenService.clear();
  if (_sessionExpiredEventSent) return;
  _sessionExpiredEventSent = true;
  window.dispatchEvent(new CustomEvent("auth:session-expired"));
}
